import React from 'react';
import PropTypes from 'prop-types';
import InternalLink from '../../InternalLink';

const Absolute = ({ handleMenuToggle, siteMotto, title }) => (
  <nav className="absolute">
    <h3 className="wordmark">
      <InternalLink onClick={handleMenuToggle} slug="home">
        {title}
      </InternalLink>
    </h3>
    <h4 className="motto">{siteMotto}</h4>
    <p>
      I{' '}
      <InternalLink onClick={handleMenuToggle} slug="craft">
        hand-craft experiences
      </InternalLink>{' '}
      that are{' '}
      <InternalLink onClick={handleMenuToggle} slug="methodology">
        user-centric, reduce friction and delight with serendipitity
      </InternalLink>
      .
    </p>
    <ul className="main-navigation">
      <li>
        <InternalLink onClick={handleMenuToggle} slug="about-me">
          find out more about me
        </InternalLink>
      </li>
      <li>
        <InternalLink onClick={handleMenuToggle} slug="clients">
          who hires me
        </InternalLink>
      </li>
      <li>
        <InternalLink onClick={handleMenuToggle} slug="services">
          how I can help
        </InternalLink>
      </li>
      <li>
        <InternalLink onClick={handleMenuToggle} slug="projects">
          projects I’ve completed recently
        </InternalLink>
      </li>
      <li>
        <InternalLink onClick={handleMenuToggle} slug="pricing">
          wondering about cost
        </InternalLink>
      </li>
      <li>
        <InternalLink onClick={handleMenuToggle} slug="every-website">
          what you get when you hire me
        </InternalLink>
      </li>
      <li>
        <InternalLink onClick={handleMenuToggle} slug="colophon">
          interested in this website
        </InternalLink>
      </li>
      <li>
        <InternalLink onClick={handleMenuToggle} slug="contact">
          contact me
        </InternalLink>
      </li>
    </ul>
  </nav>
);

Absolute.propTypes = {
  handleMenuToggle: PropTypes.func.isRequired,
  siteMotto: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Absolute;



// WEBPACK FOOTER //
// ./src/components/navigation/Absolute/index.js